import { Button } from '@prismeet/react'
import { NavLink } from 'react-router'

import { PlusIcon } from '@/shared/icons'

import { NAV_ITEMS, SIDEBAR_LABEL } from './constants'
import styles from './index.module.scss'

/**
 * Навигация активного микрофронта.
 *
 * `NavLink` сам расставляет `aria-current="page"`, и подсветка активного
 * пункта в стилях цепляется именно за него: одно состояние на глаз
 * и на скринридер, а не два независимых.
 */
export function AppSidebar() {
  return (
    <>
      <nav className={styles.nav} aria-label={SIDEBAR_LABEL}>
        {NAV_ITEMS.map(({ value, label, to, Icon }) => (
          <NavLink key={value} to={to} className={styles.navLink}>
            <Icon className={styles.navIcon} />
            {label}
          </NavLink>
        ))}
      </nav>

      <Button
        variant="solid"
        size="lg"
        fullWidth
        iconStart={<PlusIcon />}
        className={styles.compose}
      >
        Написать
      </Button>
    </>
  )
}
